<template>
  <GraphStatistics>
    <template slot="title">
      {{ $t("management.staticticsByDocDownload") }}
    </template>
    <template slot="excel">
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </template>
    <template slot="filter">
      <tr>
        <th>{{ $t("common.year") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.year"
            @change="setStatistics"
          >
            <option v-for="(year, index) in setUp.yearList" :key="index">
              {{ year }}
            </option>
          </select>
        </td>
        <th>{{ $t("management.documentType") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.firstDoctype"
            @change="setStatistics"
          >
            <option value="total">ALL</option>
            <option
              v-for="(firstDoctype, index) in setUp.firstDoctypeList"
              :key="index"
              :value="firstDoctype.doctypeId"
            >
              {{ firstDoctype.doctypeName }}
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <th>{{ $t("management.mainCategory") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.firstProdType"
            @change="changeFirstProdType"
          >
            <option value="total">ALL</option>
            <option
              v-for="(firstProdType, index) in setUp.firstProdTypeList"
              :key="index"
              :value="firstProdType.prodId"
            >
              {{ firstProdType.prodName }}
            </option>
          </select>
        </td>
        <th>{{ $t("management.subCategory") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.secondProdType"
            @change="setStatistics"
          >
            <option value="total">ALL</option>
            <option
              v-for="(secondProdType, index) in setUp.secondProdTypeList"
              :key="index"
              :value="secondProdType.prodId"
            >
              {{ secondProdType.prodName }}
            </option>
          </select>
        </td>
      </tr>
    </template>
    <template slot="graph">
      <ChartTemplate id="chartTemplate" ref="chartTemplate" />
    </template>
  </GraphStatistics>
</template>

<script>
import GraphStatistics from "@/components/management/statistics/common/GraphStatistics";
import ChartTemplate from "@/components/management/statistics/docdownload/ChartTemplate";
import { getFirstDoctypeList } from "@/api/doctype";
import { getFirstProdTypeList, getSecondProdTypeList } from "@/api/prodtype";
import { docDownloadStatisticsExcel } from "@/api/statistics";

export default {
  components: {
    ChartTemplate,
    GraphStatistics,
  },
  data() {
    return {
      setUp: {
        yearList: [],
        firstDoctypeList: [],
        firstProdTypeList: [],
        secondProdTypeList: [],
      },
      form: {
        year: "",
        firstDoctype: "",
        firstProdType: "",
        secondProdType: "",
      },
    };
  },
  async created() {
    this.setYearSelect();
    this.setFirstDoctype();
    await this.setFirstProdType();
    await this.setSecondProdType();
    this.setStatistics();
  },
  methods: {
    setYearSelect() {
      var firstYear = 2021;
      var now = new Date();
      var lastYear = now.getFullYear();
      this.form.year = lastYear;

      var yearList = [];
      for (lastYear; lastYear >= firstYear; lastYear--) {
        yearList.push(lastYear);
      }
      this.setUp.yearList = yearList;
    },
    async setFirstDoctype() {
      const response = await getFirstDoctypeList();
      this.setUp.firstDoctypeList = response.data.firstDoctypeList;
      this.form.firstDoctype = "total";
    },
    async setFirstProdType() {
      const response = await getFirstProdTypeList();
      console.log(response);
      this.setUp.firstProdTypeList = response.data.firstProdTypeList;
      this.form.firstProdType = "total";
    },
    async setSecondProdType() {
      const response = await getSecondProdTypeList(this.form.firstProdType);
      console.log(response);
      this.setUp.secondProdTypeList = response.data.secondProdTypeList;
      this.form.secondProdType = "total";
    },
    async changeFirstProdType() {
      await this.setStatistics();
      await this.setSecondProdType();
    },
    async setStatistics() {
      await this.$refs.chartTemplate.getData(
        this.form.year,
        this.form.firstDoctype,
        this.form.firstProdType,
        this.form.secondProdType
      );
    },
    async downExcel() {
      let loader = this.$loading.show({});
      let result = await docDownloadStatisticsExcel(
        this.form.year,
        this.form.firstDoctype,
        this.form.firstProdType,
        this.form.secondProdType
      );
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "StaticticsBy_DocumentsDownloaded.xls";
      link.click();
      window.URL.revokeObjectURL(url);
      loader.hide();
    },
  },
};
</script>

<style></style>
